import { render, staticRenderFns } from "./sign_settlementTask.vue?vue&type=template&id=c33d5f4c&scoped=true"
import script from "./sign_settlementTask.vue?vue&type=script&lang=js"
export * from "./sign_settlementTask.vue?vue&type=script&lang=js"
import style0 from "./sign_settlementTask.vue?vue&type=style&index=0&id=c33d5f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33d5f4c",
  null
  
)

export default component.exports